import { createFileRoute, redirect } from '@tanstack/react-router';

import { RegisterPage } from '@/pages/auth/register';

export const Route = createFileRoute('/(auth)/register')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated && context.auth.user?.is_email_verified) {
      throw redirect({ to: '/courses' });
    }
  },
  component: RegisterPage,
});
